import { useEffect, useState } from "react";
import axios from "axios";

import { API_URL } from "../config";

// Albums are the subfolders of the gallery folder on Google Drive.
export default function useAlbums() {
  const [albums, setAlbums] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      try {
        const response = await axios.get(`${API_URL}/albums`);
        if (cancelled) return;

        setAlbums(Array.isArray(response.data) ? response.data : []);
        setError(null);
      } catch (err) {
        if (!cancelled) setError("Galerii se nepodařilo načíst");
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    load();

    return () => {
      cancelled = true;
    };
  }, []);

  return { albums, loading, error };
}
